export default (time, fmt) => {
  let format = fmt || "yyyy-MM-dd hh:mm";
  if (!time) {
    return "";
  }
  let date = new Date(parseInt(time, 10));
  let o = {
    "y+": date.getFullYear(),
    "M+": date.getMonth() + 1,
    "d+": date.getDate(),
    "h+": date.getHours(),
    "m+": date.getMinutes(),
    "s+": date.getSeconds()
  };

  for (let k in o) {
    if (new RegExp(`(${k})`).test(format)) {
      let str = `${o[k]}`;
      str = str.length > 1 ? str : 0 + str;
      format = format.replace(RegExp.$1, str);
    }
  }

  return format;
};

export const formatSmallTime = (s) => {
  let t = '';
  if (s > -1){
      const min = Math.floor(s / 60) % 60;
      const sec = s % 60;
      if (min < 10){t += "0";}
      t += min + "'";
      if (sec < 10){t += "0";}
      t += sec.toFixed(2);
  }
  // eslint-disable-next-line no-useless-escape
  t = t.replace('.','\"')
  return t;
}
